import store from '../store/Store';
import { mutatorAction } from 'satcheljs';
import isKeyboardShortcutsDisabled from 'owa-hotkeys/lib/utils/isKeyboardShortcutsDisabled';

const setIsHotkeysMapVisibleMutator: (isVisible: boolean, checkIfDisabled?: boolean) => void =
    mutatorAction(
        'setIsHotkeysMapVisible',
        function setIsHotkeysMapVisible(isVisible: boolean, checkIfDisabled?: boolean): void {
            if (!checkIfDisabled || !isKeyboardShortcutsDisabled()) {
                store().isVisible = isVisible;
            }
        }
    );
export default setIsHotkeysMapVisibleMutator;
